
import { Component, Vue } from 'vue-property-decorator'
import AppInput from '@/components/AppInput.vue'
import AppButton from '@/components/AppButton.vue'
import LoginGoogleButton from '@/components/LoginGoogleButton.vue'

@Component({
    components: {
        AppInput,
        AppButton,
        LoginGoogleButton,
    },
})
export default class Login extends Vue {
    public email: string = ''
    public password: string = ''

    public mounted() {
        this.$store.dispatch('doLogout')
    }

    get error() {
        return this.$store.state.auth.message || ''
    }

    get isLoading() {
        return this.$store.state.auth.isLoading
    }
}
